import {Component, Inject} from '@angular/core';
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActiveUserService} from "../../../services/active-user.service";
import {SnackbarService} from "../../../services/snackbar.service";
import {DateService} from "../../../services/date.service";
import {GameService} from "../../../services/game.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IStopGame} from "../../../interfaces/IStopGame";
import {IApiErrorResponse} from "../../../interfaces/error/IApiErrorResponse";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";

@Component({
  selector: 'app-stop-game-dialog',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatButton,
    MatFormField,
    MatHint,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule
  ],
  templateUrl: './stop-game-dialog.component.html',
  styleUrl: './stop-game-dialog.component.css'
})
export class StopGameDialogComponent {
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  public stopGameWhenOption = new FormControl<string | null>(null, [Validators.required]);

  readonly STOP_AFTER_DRAW = "after-draw";
  readonly STOP_AFTER_WINNER = "after-winner";

  public stopGameForm = new FormGroup({
    stopGameWhen: this.stopGameWhenOption
  });

  constructor(private activeUserService: ActiveUserService,
              private snackBarService: SnackbarService,
              private gameService: GameService,
              private matDialogRef: MatDialogRef<StopGameDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public game: IGameQueryResult) {
    this.stopGameWhenOption.setValue(this.STOP_AFTER_DRAW);
  }

  submit() {
    this.uiState = UIStateEnum.ShowLoading;

    if (this.stopGameForm.invalid) {
      this.stopGameForm.markAllAsTouched();
      return;
    }

    let command: IStopGame = {
      AdminId: this.activeUserService.activeUser().Id,
      GameId: this.game.Id,
      StopWhen: this.stopGameWhenOption.value!,
    }

    this.gameService.stopGame(command).subscribe({
      next: () => {
        this.matDialogRef.close();
        this.snackBarService.openSuccessfulSnackBar('Successfully stopped the game.');
      }, error: (res: IApiErrorResponse) => {
        this.uiState = UIStateEnum.ShowData;
        if (res.Error?.ClientErrorMessages?.length > 0) {
          this.snackBarService.openErrorSnackBar(res.Error.ClientErrorMessages.toString());
        } else {
          this.snackBarService.openErrorSnackBar('There was an error stopping the game');
        }
      }
    })
  }
}

